import { ResourceConfig } from './configs/resource-config';

export type ResourceType = 'vm' | 'db' | 'app' | 'acc' | '';

/**
 * Represents metadata information about a resource
 *
 * This class contains descriptive information that identifies and categorizes a resource,
 * providing context about its purpose, type, and versioning.
 */
export class ResourceMetaData {
  /**
   * Display name of the resource
   *
   * A human-readable identifier used for display purposes in user interfaces.
   */
  name: string = '';

  /**
   * Type classification of the resource
   *
   * Categorizes the resource (e.g., "VirtualMachine", "Database", "NetworkResource").
   * This helps determine how the resource data should be processed and displayed.
   */
  type: ResourceType = '';

  /**
   * Version number of the resource metadata schema
   *
   * Used for tracking schema changes and ensuring backward compatibility
   * when resource definitions evolve over time.
   */
  version: number = 1;

  /**
   * Detailed description of the resource
   *
   * Provides additional context about the resource's purpose, usage guidelines,
   * or any other relevant information for users and administrators.
   */
  description: string = '';

  constructor() {
  }

  static fromConfig(config: ResourceConfig): ResourceMetaData {
    const resourceMetaData = new ResourceMetaData();
    resourceMetaData.name = config.name;
    resourceMetaData.type = config.type;
    resourceMetaData.description = config.description;
    return resourceMetaData;
  }
}

